export default __webpack_public_path__ + "static/media/F7.267a4d2d.gif";